import { render, staticRenderFns } from "./tqm.vue?vue&type=template&id=84e216ea&scoped=true&"
import script from "./tqm.vue?vue&type=script&lang=js&"
export * from "./tqm.vue?vue&type=script&lang=js&"
import style0 from "./tqm.vue?vue&type=style&index=0&id=84e216ea&scoped=true&lang=css&"
import style1 from "./tqm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e216ea",
  null
  
)

export default component.exports